import { MaintenanceService } from '@/src/app/core/maintenance/maintenance.service';
import { BaseComponent } from '@/src/app/shared/components/base-component/base.component';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { AuthenticationContainerComponent } from '../../../features/authentication/authentication-container/authentication-container.component';

import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'stx-maintenance-page',
  templateUrl: './maintenance-page.component.html',
  imports: [AuthenticationContainerComponent, TranslateModule]
})
export class MaintenancePageComponent extends BaseComponent implements OnInit, OnDestroy {
  private readonly maintenanceService = inject(MaintenanceService);

  private intervalHandle: number;
  get message() {
    return this.maintenanceService.message;
  }
  get isTranslated() {
    return this.maintenanceService.hasTranslationKey;
  }

  ngOnInit(): void {
    this.intervalHandle = this.maintenanceService.pollCurrentUserAndNavigateOnSuccess(this.subSink);
  }

  ngOnDestroy(): void {
    window.clearInterval(this.intervalHandle);
  }
}
